import { FieldType, JournalPublicationInfoField, MagazineNewspaperPublicationField, RowType } from '../../../../components/GenericSection';
import { END, START } from '../../../constants';
var COMMON_PUBINFO_SECTION_FIELDS = {
  MAGAZINE: [{
    field: MagazineNewspaperPublicationField.TITLE,
    labelText: 'Magazine title',
    recommended: false,
    type: FieldType.TEXT
  }, {
    rowtype: RowType.SM_TWO_ROW,
    fields: [{
      field: MagazineNewspaperPublicationField.VOLUME,
      labelText: 'Volume',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }, {
      field: MagazineNewspaperPublicationField.ISSUE,
      labelText: 'Issue',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }]
  }, {
    field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
    type: FieldType.PUBDATE,
    labelText: 'Date published',
    formikFieldNames: ['day', 'month', 'year']
  }, {
    fields: [{
      field: MagazineNewspaperPublicationField.START_PAGE,
      labelText: START,
      recommended: false,
      type: FieldType.TEXT
    }, {
      field: MagazineNewspaperPublicationField.END_PAGE,
      labelText: END,
      recommended: false,
      type: FieldType.TEXT
    }]
  }, {
    field: MagazineNewspaperPublicationField.NON_CONSECUTIVE,
    labelText: 'Pages are nonconsecutive',
    type: FieldType.CHECKBOX
  }],
  NEWSPAPER: [{
    field: MagazineNewspaperPublicationField.TITLE,
    labelText: 'Newspaper title',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.CITY,
    labelText: 'City',
    recommended: false,
    type: FieldType.TEXT
  }, {
    rowtype: RowType.SM_TWO_ROW,
    fields: [{
      field: MagazineNewspaperPublicationField.EDITION,
      labelText: 'Edition',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }, {
      field: MagazineNewspaperPublicationField.SECTION,
      labelText: 'Section',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }]
  }, {
    field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
    type: FieldType.PUBDATE,
    labelText: 'Date published',
    formikFieldNames: ['day', 'month', 'year']
  }, {
    fields: [{
      field: MagazineNewspaperPublicationField.START_PAGE,
      labelText: START,
      recommended: true,
      type: FieldType.TEXT
    }, {
      field: MagazineNewspaperPublicationField.END_PAGE,
      labelText: END,
      recommended: true,
      type: FieldType.TEXT
    }]
  }, {
    field: MagazineNewspaperPublicationField.NON_CONSECUTIVE,
    labelText: 'Pages are nonconsecutive',
    type: FieldType.CHECKBOX
  }],
  JOURNAL: [{
    field: JournalPublicationInfoField.TITLE,
    labelText: 'Journal title',
    recommended: false,
    type: FieldType.TEXT
  }, {
    rowtype: RowType.SM_TWO_ROW,
    fields: [{
      field: JournalPublicationInfoField.VOLUME,
      labelText: 'Volume',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }, {
      field: JournalPublicationInfoField.ISSUE,
      labelText: 'Issue',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }, {
      field: JournalPublicationInfoField.SERIES,
      labelText: 'Series',
      recommended: false,
      type: FieldType.TEXT,
      flex: '2'
    }]
  }, {
    field: JournalPublicationInfoField.RESTARTS,
    labelText: 'Every issue restarts page numbering',
    type: FieldType.CHECKBOX
  }, {
    field: JournalPublicationInfoField.PUBLISHED_DATE,
    type: FieldType.PUBDATE,
    labelText: 'Date published',
    formikFieldNames: ['day', 'month', 'year']
  }, {
    fields: [{
      field: JournalPublicationInfoField.START_PAGE,
      labelText: START,
      recommended: true,
      type: FieldType.TEXT
    }, {
      field: JournalPublicationInfoField.END_PAGE,
      labelText: END,
      recommended: true,
      type: FieldType.TEXT
    }]
  }, {
    field: JournalPublicationInfoField.NON_CONSECUTIVE,
    labelText: 'Pages are nonconsecutive',
    type: FieldType.CHECKBOX
  }]
};
export default COMMON_PUBINFO_SECTION_FIELDS;